<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      @if (!project) {
        <h1>{{'Create project' | translate}}</h1>
      }
      @if (project) {
        <h1>{{'Edit project' | translate}}</h1>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="L-6 M-6 S-12 columns">
          <app-image-uploader
            [allowed_extensions]="['PNG', 'JPG','png', 'jpg', 'gif', 'jpeg']"
            [multiple]="false"
            [prefix_name]="'_test_image/'"
            [quality_compression]="1024"
            [allowSendMultiple]="true"
            [height]="'185px'"
            (fileListSend)="sendFiles($event)">
          </app-image-uploader>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <label>{{'Project type' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.type"
            [list]="viewData.project_types"
            [value]="'id'"
            [name]="'name'"
            [backTranslate]="true"
            [required]="true"
            (onClose)="onChangeType()">
          </app-dropdown>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <label>{{'Project status' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.status"
            [list]="viewData.project_statuses"
            [value]="'id'"
            [name]="'name'"
            [required]="true"
            [backTranslate]="true">
          </app-dropdown>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <label>{{'Project category' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.category"
            [list]="viewData.project_categories"
            [value]="'id'"
            [name]="'name'"
            [required]="true"
            [backTranslate]="true">
          </app-dropdown>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <label>{{'Production center' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.productionCountry"
            [list]="viewData.production_centers"
            [value]="'id'"
            [name]="'prod_center'"
            [required]="true"
            [backTranslate]="true"
          ></app-dropdown>
        </div>
        <div class="L-12 M-12 S-12 columns">
          <label>{{'Project name' | translate}}**</label>
          <input type="text" name="name" [(ngModel)]="formData.name" placeholder="{{'Insert text' | translate}}" required>
        </div>
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Abbreviation' | translate}}</label>
          <input type="text" name="abbr" [(ngModel)]="formData.abbr" placeholder="{{'Insert text' | translate}}">
        </div>
        <div class="L-6 M-6 S-6 columns">
          <label>{{'Abbreviation' | translate}} EDL</label>
          <input type="text" name="abbreviation_edl" [(ngModel)]="formData.abbreviation_edl" placeholder="{{'Insert text' | translate}}">
        </div>
        <div class="row">
          @if (formData.type == 1) {
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Season' | translate}}</label>
              <input type="text" class="number" name="season" [(ngModel)]="formData.season" placeholder="{{'Insert number' | translate}}">
            </div>
            <div class="L-4 M-4 S-6 columns">
              <label>{{'Episodes' | translate}}**</label>
              <input type="text" class="number" name="episodes" [(ngModel)]="formData.episodes" required placeholder="{{'Insert number' | translate}}">
            </div>
          }
          <div class="L-4 M-4 S-6 columns">
            <label>{{'Duration' | translate}}**</label>
            <app-minutes-input [required]="true" [(appModel)]="formData.duration"></app-minutes-input>
          </div>
        </div>
        <div class="L-12 M-12 S-12 columns">
          <label>{{'Shoting configuration types' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.list_shooting_config_time"
            [list]="viewData.shooting_config_types"
            [value]="'id'"
            [name]="'config_type'"
            [multiple]="true"
            [backTranslate]="true"
            [required]="true"
          ></app-dropdown>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <h3>{{'Pre-production dates' | translate }}</h3>
          <div class="L-3 M-3 S-3 columns">
            <label>{{'Weeks' | translate}}</label>
            <input
              type="text"
              class="number"
              name="weeks_pre_production"
              [(ngModel)]="formData.weeks_pre_production"
              [required]="formData.pre_production_start"
              (ngModelChange)="calculateEndDates('weeks_pre_production', 'pre_production_start', 'pre_production_end');"
              placeholder="{{'Insert' | translate}}">
          </div>
          <div class="L-9 M-9 S-9 columns">
            <label>{{'Start date' | translate}}</label>
            <input
              type="date"
              class="date"
              name="pre_production_start"
              [(ngModel)]="formData.pre_production_start"
              [required]="formData.weeks_pre_production"
              (ngModelChange)="calculateEndDates('weeks_pre_production', 'pre_production_start', 'pre_production_end');">
          </div>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <h3>{{'Production dates' | translate}}</h3>
          <div class="L-3 M-3 S-3 columns">
            <label>{{'Weeks' | translate}}</label>
            <input
              type="text"
              class="number"
              name="weeks_production"
              [(ngModel)]="formData.weeks_production"
              [required]="formData.production_start"
              (ngModelChange)="calculateEndDates('weeks_production', 'production_start', 'production_end');"
              placeholder="{{'Insert' | translate}}">
          </div>
          <div class="L-9 M-9 S-9 columns">
            <label>{{'Start date' | translate}}</label>
            <input
              type="date"
              class="date"
              name="production_start"
              [(ngModel)]="formData.production_start"
              [required]="formData.weeks_production"
              [attr.min]="formData.pre_production_end ? formData.pre_production_end : null"
              (ngModelChange)="calculateEndDates('weeks_production', 'production_start', 'production_end');">
          </div>
        </div>
        <div class="L-6 M-6 S-12 columns">
          <h3>{{'Post-production dates' | translate}}</h3>
          <div class="L-3 M-3 S-3 columns">
            <label>{{'Weeks' | translate}}</label>
            <input
              type="text"
              class="number"
              name="weeks_pos_production"
              [(ngModel)]="formData.weeks_pos_production"
              [required]="formData.pos_production_start"
              (ngModelChange)="calculateEndDates('weeks_pos_production', 'pos_production_start', 'pos_production_end')"
              placeholder="{{'Insert' | translate}}">
          </div>
          <div class="L-9 M-9 S-9 columns">
            <label>{{'Start date' | translate}}</label>
            <input
              type="date"
              class="date"
              name="pos_production_start"
              [(ngModel)]="formData.pos_production_start"
              [attr.min]="formData.production_end ? formData.production_end : null"
              (ngModelChange)="calculateEndDates('weeks_pos_production', 'pos_production_start', 'pos_production_end')">
          </div>
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid || !formData.status">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>